






import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

import { Vehicle } from '@/modules/Vehicle/interfaces/vehicle'
import AppSystemInfoCard from '@/components/AppSystemInfoCard.vue'

@Component({
  components: {
    AppSystemInfoCard
  }
})
export default class VehicleDetailAdditional extends Vue {
  @Prop({ type: Object as () => Vehicle }) readonly vehicle!: Vehicle
}
